<main id="main-content" tabindex="-1">
 <div *ngIf="resource" class="content-contain mx-auto my-4">
    <prism-title additionalClasses="text-4xl text-center sm:text-left" [title]="resource.title"></prism-title>
    @if (isEditable) {
      <prism-btn btnClass="btn-white" (click)="goToResourceForm()">
        <i class="uil uil-edit text-lg"></i>
        <span class="text-lg"> Edit resource</span>
      </prism-btn>
    }
    <hr class="h-1 bg-dark-purple border-0 my-4">
    <p class="font-bold text-dark-purple text-4xl">Description</p>
    <p class="mb-6">{{ resource.description }}</p>
    <prism-btn btnClass="btn-purple" (click)="goToResource()">{{ resource.buttonLabel }}</prism-btn>
  </div>
</main>
